import { useState } from "react";
import { Button } from "@shared/src/components/ui/button";
import { CustomCheckbox } from "@shared/src/components/common/form-components/CustomCheckbox";

interface ReleaseConfirmationDialogProps {
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ReleaseConfirmationDialog = ({ onConfirm, onCancel }: ReleaseConfirmationDialogProps) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  const handleConfirm = () => {
    if (isConfirmed) {
      setIsOpen(false);
      onConfirm();
    }
  };

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      onCancel?.();
    }
  };

  return (
    <div className="space-y-4 px-4">
      <p className="!font-normal">
        Please confirm that you have received the payment in your selected payment account.
      </p>
      <p className="!font-normal text-red-500">
        WARNING: This action is irreversible. iExchange will not be responsible for any mistakes. Only release crypto if
        you are 100% certain you have received payment.
      </p>
      <div className="flex p-3 border-border-tertiary border rounded-xl items-center gap-2 mt-4">
        <CustomCheckbox
          id="confirm-payment"
          checked={isConfirmed}
          onCheckedChange={checked => setIsConfirmed(checked === true)}
        />
        <label
          htmlFor="confirm-payment"
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          I confirm that I have received the payment and understand this action cannot be undone
        </label>
      </div>
      <div className="flex justify-center gap-4 mt-4">
        <Button onClick={onCancel} variant="secondary" size="lg" radius="full" width="full">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={!isConfirmed}
          variant="tertiary"
          size="lg"
          radius="full"
          width="full"
          className={`${isConfirmed ? "" : "bg-gray-300 text-gray-500"}`}
        >
          Release Crypto
        </Button>
      </div>
    </div>
  );
};
